module.exports = __webpack_public_path__ + "static/media/grand_mum_why aren_t you eating.88ce6ccb.gif";